<template lang="pug">
    .multy-autocomplete(ref="parent" v-bind:class="{ 'inline': $props.inline, 'focused': showSearch}")
        .multy-autocomplete-container(v-bind:class="{'has-error': (error || errors.has('isSelected')), 'focused': showSearch, 'has-value': (previewValue && previewValue.length), 'disabled': $props.disabled, 'readonly': $props.readonly }")
            label(v-if="$props.label" v-bind:for="$props.id" v-html="$props.label + (($props.required) ? '<span>*</span>' : '') + ($props.readonly ? ' (только для чтения)' : '') + ($props.loading ? ' (загрузка)' : '')")
            .preview-container(v-bind:class="{'disabled': $props.disabled, 'readonly': $props.readonly}")
                .preview(v-on:click="toggleSearch" v-bind:placeholder="$props.placeholder" v-bind:class="{'can-add': $props.canAdd && !$props.disabled}")
                    .value
                        span.value-item(v-for="value in previewValue") 
                            span.value-item-span {{value.value}}
                            span.tolltip(v-if="getTooltip(value.item)" v-html="getTooltip(value.item)")
                    .btn(v-show="showSearchInput || findResult.length || selectedResult.length")
                .add-btn(v-show="$props.canAdd && !showAdd" v-on:click="showAddForm" v-if="!$props.disabled")
                    i.fa.fa-plus
                .add-btn(v-show="$props.canAdd && showAdd" v-on:click="hideAddForm" v-if="!$props.disabled")
                    i.fa.fa-minus
            md-progress-bar#progress-bar.md-accent(md-mode="indeterminate" v-show="loading" style="top: 46px; height: 2px; z-index: 900; position: absolute;")
        .search-main-container
            .search-container(v-show="showSearch && (showSearchInput || findResult.length || selectedResult.length)")
                z-input(
                    v-if="showSearchInput && !(this.$props.readonly || this.$props.disabled)"
                    v-bind:name="$props.name + '-search'" 
                    v-bind:id="$props.id + '-search'" 
                    v-bind:showLabel="false"
                    placeholder="Поиск..."
                    v-model="searchString"
                    v-bind:loading="loading"
                    ref="search"
                    autocomplete="off"
                    v-bind:readonly="$props.readonly"
                    v-bind:disabled="$props.disabled"
                )
                .showed-items
                    .showed-item(v-for="(item, i) in selectedResult" v-bind:key="i")
                        .icon_container(v-on:click="unselectItem(item, false)")
                            span.icon
                        span(v-on:click="unselectItem(item, true)") {{ item[$props.displayProperty] }}
                .finded-items
                    .finded-item(v-for="(item, i) in findResult" v-bind:key="i")
                        .icon_container(v-on:click="selectItem(item, false)")
                            span.icon
                        span(v-on:click="selectItem(item, true)") {{ item[$props.displayProperty] }}
        span.md-error.error(v-if="error") {{error}}
        span.md-error.error(v-if="!error && errors.has('isSelected')") Необходимо выбрать значение из списка

        .new-entity(v-if="$props.canAdd && showAdd")
            slot
</template>
<script>
  import ZInput from '@/components/ZInput'
  export default {
    components: {ZInput},
    name: 'multy-autocomplete',
    props: {
        placeholder: {
            type: String,
            default: ''
        },
        items: {
            type: Array,
            default: () => []
        },//массив с объектами элементов, по которым будет идти поиск - [{id: 1, name: 'name 1'}, {id: 2, name: 'name 2'}]
        displayProperty: {
            type: String,
            default: ''
        }, //свойство объектов в массиве, коорое будет выводиться в списке поиска
        return: {
            type: String,
            default: 'id'
        },   //свойство объектов в массиве, значене которого будет возвращаться в качестве результата - id
        returnAll: {
            type: Boolean,
            default: false
        }, //если передать true, то будет возвращать не поле объекта, а весь объект
        clearAfterSelect: {
            type: Boolean,
            default: false
        }, //если передать true, поле поиска будет очищаться после выбора
        label: {
            type: String,
            default: ''
        }, //заголовок для поля
        value: {
            type: [String, Boolean, Number, Array, Object],
            default: () => ''
        }, //значение поля, должно быть = свойству, указнному в return, для одного из элементов - 2
        callback: {
            type: Function,
            default: () => {}  
        }, //функция, которая возвращает список для автозаполнения
        default: {
            type: String,
            default: ''
        }, //текстовое значение поля, если используется callback,
        showOnFocus: {
            type: Boolean,
            default: false
        }, //если установенно в true, то выпадающий список будет показываться по фокусу на инпуте, для этого обязательно указывать параметр items
        disabled: {
            type: Boolean,
            default: false
        },
        readonly: {
            type: Boolean,
            default: false
        },
        error: {
            type: String,
            default: ''
        },
        fixed: {
            type: Boolean,
            default: false
        },
        required: {
            type: Boolean,
            default: false
        }, //позиционировать выпадающее меню относительно окна
        id: {
            type: String,
            default: ''
        },
        name: {
            type: String,
            default: ''
        },
        deafaultObject: {
            type: Object,
            default: () => {}
        },
        mask: {
            type: String,
            default: ''
        },
        searchLength: {
            type: Number,
            default: 3
        },
        showSearchInput: {
            type: Boolean,
            default: true
        },
        canAdd: {
            type: Boolean,
            default: false
        },
        tolltipFields: {
            type: Object,
            default: () => {
                return {}
            }
        },
        inline: {
            type: Boolean,
            default: false
        },
        dirty: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isDirty: false,
            loading: false,
            showSearch: false,
            showAdd: false,
            searchString: '',
            inputValue: [],

            findResult: [],
            selectedResult: [],
            findResultVal: [],
            selectedResultVal: [],
        }
    },
    created() {
        this.init();
    },
    computed: {
        previewValue() {
            if (!this.selectedResult || this.selectedResult.legnth < 1) return [];
            return this.selectedResult.map(item => {
                return {value: item[this.$props.displayProperty], item: item};
            });
        }
    },
    methods: {
        init() {
            this.$nextTick(() => {
                this.listeners();
                this.selectedResult = [];
                this.selectedResultVal = [];
                if (this.$props.value) {
                    this.selectedResult = Object.assign([], this.$props.value);
                    this.selectedResult.map(item => {
                        this.selectedResultVal.push(item[this.$props.displayProperty]);
                    });
                }
                if (this.$props.items && this.$props.items.length) this.addSearchResult(this.$props.items);
                else {
                    this.findResult = [];
                    this.findResultVal = [];
                }
            });
        },
        listeners() {
            document.addEventListener('click', e => {
                if (this.$refs && this.$refs.parent && !this.$refs.parent.contains(e.target)) this.showSearch = false;
            });
        },
        change() {
            this.$emit('change', this.selectedResult);
            this.$emit('input', this.selectedResult);
        },
        toggleSearch() {
            this.showSearch = !this.showSearch;
        },
        selectItem(item, close) {
            if (this.$props.readonly || this.$props.disabled) return;
            this.selectedResult.push(item);
            this.selectedResultVal.push(item[this.$props.displayProperty]);

            let findResult = Object.assign([], this.findResult);
            this.addSearchResult(findResult);
            this.sortLists();
            this.change();
            if (close) this.showSearch = false;
            this.emitDirty();
        },
        unselectItem(item, close) {
            if (this.$props.readonly || this.$props.disabled) return;
            let key = null;
            this.selectedResult.map((el, i) => {
                if (item[this.$props.displayProperty] == el[this.$props.displayProperty]) key = i;
            });

            this.findResultVal.push(key);
            this.findResult.push(item);
            this.selectedResult.splice(key, 1);
            this.selectedResultVal.splice(key, 1);
            this.sortLists();
            this.change();
            if (close) this.showSearch = false;
            this.emitDirty();
        },
        search() {
            if (this.$props.items && this.$props.items.length) {
                this.addSearchResult(this.$props.items);
                return;
            }
            if (!this.loading && this.callback && typeof this.callback === 'function' ) {
                this.loading = true;
                this.callback(this.searchString).then(result => {
                    if (result.body && result.body.response) {
                        if (result.body.response.data) this.addSearchResult(result.body.response.data);
                        else this.addSearchResult(result.body.response);
                    } else this.addSearchResult(result);
                    this.loading = false;
                }).finally(() => this.loading = false);
            }
        },
        addSearchResult(items) {
            this.findResult = Object.assign([], []);
            items.map(item => {
                let key = item[this.$props.displayProperty];
                if (!(this.selectedResultVal.indexOf(key)+1)) {
                    this.findResultVal.push(key);
                    this.findResult.push(item);
                }
            });
            this.sortLists();
        },
        sortLists() {
            this.selectedResult.sort((a, b) => {
                if(a[this.$props.displayProperty] < b[this.$props.displayProperty]) return -1;
                if(a[this.$props.displayProperty] < b[this.$props.displayProperty]) return 1;
                return 0;
            });
            
            this.findResult.sort((a, b) => {
                if(a[this.$props.displayProperty] < b[this.$props.displayProperty]) return -1;
                if(a[this.$props.displayProperty] < b[this.$props.displayProperty]) return 1;
                return 0;
            });
        },
        showAddForm() {
            this.showAdd = true;
        },
        hideAddForm() {
            this.showAdd = false;
        },
        getTooltip(item) {
            if (!item || !this.$props.tolltipFields || !Object.keys(this.$props.tolltipFields).length) return;
            let result = [];
            Object.keys(this.$props.tolltipFields).map(key => {
                let label = this.$props.tolltipFields[key];
                if (item.hasOwnProperty(key) && item[key]) result.push((label + ': ' + item[key])); 
            });
            return result.join('<br/>');
        },
        emitDirty() {
            this.isDirty = true;
            this.$emit('update:dirty', this.isDirty);
        },
    },
    watch: {
        '$props.value': {
            deep: true,
            handler(val) {
                if (JSON.stringify(val) != JSON.stringify(this.selectedResult)) this.init();
            }
        },
        'searchString'(searchString) {
            if (searchString.length >= this.$props.searchLength) this.search();
        },
        '$props.items': {
            deep: true,
            handler(items) {
                this.init();
            }
        },
        '$props.dirty'(val) {
            if (val && this.isDirty !== val) this.emitDirty();
        }
    }
  }
</script>
<style scoped lang="sass">
    .multy-autocomplete
        width: 100%
        margin: 4px 0 10px 0
        .error
            display: block
            height: auto
            min-height: 15px
            font-size: 11px
            line-height: 11px
            padding: 8px 0 0
            color: #ff1744
        .multy-autocomplete-container
            position: relative
            label
                display: block
                color: rgba(0, 0, 0, 0.54)
                font-size: 12px
                font-weight: 500
                line-height: 12px
                transition: .4s cubic-bezier(.25,.8,.25,1)
                transition-duration: .3s
                z-index: 5
                resize: none
                margin-bottom: 10px
                span
                    color: #D66565
            &.has-error
                label
                    color: #ff1744
                .preview-container
                    border: 1px solid #D66565
                    background: hsla(0,58%,62%,.1)
        .preview-container
            display: flex
            align-items: center
            justify-content: space-between
            background: #F1F1F1
            padding: 2px 4px
            &.disabled, &.readonly
                background: #eaeaeaea
            .add-btn
                display: flex
                align-items: center
                justify-content: center
                min-height: 18px
                width: 18px
                flex-shrink: 0
                background: #2196F3
                cursor: pointer
                border-radius: 3px
                transition: 0.4s cubic-bezier(0.4, 0, 0.2, 1)
                will-change: background-color,opacity
                &:hover
                    background: #3BA2F4
                svg
                    color: #fff
                    display: block
                    width: 10px
                    height: 10px
                    font-size: 10px
                    line-height: 10px
                    box-sizing: border-box
                    vertical-align: baseline

        .preview
            display: flex
            align-items: center
            justify-content: flex-start
            flex-wrap: wrap
            font-size: 14px
            border: none
            background: transparent
            outline: none
            color: #000
            font-weight: 400
            min-height: 26px
            width: 100%
            position: relative
            z-index: 10

            &.can-add
                width: calc(100% - 24px)
            .value
                width: calc(100% - 26px)
                display: flex
                flex-wrap: wrap
                align-items: flex-start
                justify-content: flex-start
                cursor: default
                .value-item
                    margin: 2px
                    background: #fff
                    padding: 0px 2px
                    border-radius: 3px
                    position: relative
                    font-size: 12px
                    line-height: 12px
                    height: 16px
                    display: flex
                    align-items: center
                    justify-content: center
                    max-width: 100%
                    span.value-item-span
                        width: 100%
                        white-space: nowrap
                        text-overflow: ellipsis
                        overflow: hidden
                    &:hover
                      .tolltip
                          opacity: 1
                          visibility: visible
                    .tolltip
                        content: ''
                        display: block
                        position: absolute
                        bottom: 25px
                        left: 0
                        background: rgba(0, 0, 0, 0.7)
                        border-radius: 3px
                        color: #fff
                        font-size: 11px
                        line-height: 12px
                        padding: 4px
                        opacity: 0
                        visibility: hidden
                        transition: 0.2s ease-in-out
                        &:after
                            content: ''
                            display: block
                            position: absolute
                            border-radius: 3px
                            border: 5px solid transparent
                            border-top: 4px solid rgba(0, 0, 0, 0.8)
                            bottom: -9px
                            left: 10px
            .btn
                display: flex
                align-items: center
                justify-content: center
                margin: auto 0 auto auto
                width: 26px
                height: 26px
                transition: 0.2s ease-in-out
                &::before
                    content: ''
                    display: block
                    width: 10px
                    height: 10px
                    border-bottom: 1px solid #000
                    border-right: 1px solid #000
                    transform: rotate(45deg)
                    margin: -5px 0 0 0
            .close
                background: #eee
                width: 10px
                height: 10px
                cursor: pointer
        .search-main-container
            position: relative
        .search-container
            position: absolute
            background: #fff
            box-shadow: 0 2px 1px -1px rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 1px 3px 0 rgba(0, 0, 0, 0.12)
            z-index: 1000
            min-width: 100%
            padding: 5px
            max-height: 300px
            overflow-y: auto
            overflow-x: hidden
        .showed-items, .finded-items
        .showed-item, .finded-item
            display: flex
            align-items: center
            justify-content: flex-start
            cursor: default
            .icon_container
                display: flex
                align-items: center
                justify-content: center
                width: 22px
                height: 22px
                margin: 0 5px 0 0
            .icon
                display: flex
                align-items: center
                justify-content: center
                width: 18px
                height: 18px
                position: relative
                background: #eee
                &::before, &::after
                    display: block
                    content: ''
                    width: 10px
                    height: 2px
                    background: #000
                &::after
                    width: 2px
                    height: 10px

        .showed-item
            .icon
                &::before
            .icon
                &::after
                    display: none
                
        .finded-item
            .icon
                &::before
                    position: absolute
                    top: 7px
            .icon
                &::after
                    position: absolute
                    top: 3px
                    left: 8px
        &.inline
            .multy-autocomplete-container
                display: flex
                align-items: center
                padding: 0
            label
                width: 40%
                flex: 0 0 40%
                padding-right: 8px
                margin: 0
            .preview-container
                flex-grow: 1
                max-width: 60%
            .search-container
                margin-left: 40%
                min-width: 60%
            .error
                width: 60%
                margin: 0 0 auto auto
        &.focused
            .preview
                .btn
                    transform: rotate(90deg)
</style>



// WEBPACK FOOTER //
// MultyAutocomplete.vue?4914cf91